var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isPNMAvailable
    ? _c(
        "div",
        {
          staticClass: "payments__instruments_item pay-near-me",
          class: { diss: _vm.disabled },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.go2PayNearMe()
            }
          }
        },
        [
          _c("span", { staticClass: "piitem-picture" }, [
            _c("img", {
              attrs: {
                src: _vm.mediaServer(
                  "/static/brand-img/" + _vm.brandKey + "/paynearme.svg"
                ),
                alt: "pnm"
              }
            })
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "piitem-text" }, [
            _c("div", { staticClass: "piitem-text-headline" }, [
              _vm._v(_vm._s(_vm.$t("Transaction.PayNearMe")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "piitem-text-desc" }, [
              _vm._v(_vm._s(_vm.$t("Transaction.PayNearMe.Desc")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "piitem-arrow" },
            [_c("v-icon", [_vm._v("chevron_right")])],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5dbbb7e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dbbb7e9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/PayNearMeItem.vue
// module id = null
// module chunks = 